module.exports = __webpack_public_path__ + "img/chevron-right-black.adc7ffdb.svg";